const defaultRender = (value) => (value ? value : "--");

const totalfiles = [
  {
    title: "Name",
    dataIndex: "service_name",
    render: defaultRender,
  },
  {
    title: "File No.",
    dataIndex: "file_number",
    render: defaultRender,
  },
  {
    title: "Created Date",
    dataIndex: "date_created",
    render: defaultRender,
  },
  {
    title: "Progress",
    dataIndex: "progress",
    render: defaultRender,
    width: 250,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
  {
    title: "Action",
    dataIndex: "action",
    render: defaultRender,
  }
];

export default totalfiles;
